import AppImage from '@theme/components/atom/AppImage'
import AppTitle from '@theme/components/atom/AppTitle'
import BranchBox from '@theme/components/content/BranchBox'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import Divider from '@theme/components/molecule/Divider'
import DummyPlaceholder from '@theme/components/atom/DummyPlaceholder'
import GoogleMap from '@theme/components/utils/GoogleMap/GoogleMapLazy'
import GoogleMapLink from '@theme/components/atom/GoogleMapLink'
import LayoutBase from '@theme/components/shop/LayoutBase'
import OpeningHours from '@theme/components/shop/OpeningHours'
import ProductsVisited from '@theme/components/product/ProductsVisited/ProductsVisitedLazy'
import SeoMixin from '~/mixins/SeoMixin'
import UniqueSellingPoints from '@theme/components/shop/UniqueSellingPoints'
import Wysiwyg from '@theme/components/utils/Wysiwyg'

export default {
  components: {
    AppImage,
    AppTitle,
    BranchBox,
    Breadcrumbs,
    Divider,
    DummyPlaceholder,
    GoogleMapLink,
    GoogleMap,
    LayoutBase,
    OpeningHours,
    ProductsVisited,
    UniqueSellingPoints,
    Wysiwyg,
  },
  mixins: [SeoMixin],
  computed: {
    lightBoxItems() {
      const items = []
      items.push({
        src: this.branch.main_image && this.branch.main_image[0].path,
        title: '',
        type: 'image',
      })
      this.branch.images.forEach(image => {
        items.push({
          src: image.path,
          title: '',
          type: 'image',
        })
      })
      return items
    },
    phone() {
      return this.branch.storeBranch.phone && this.branch.storeBranch.phone.replace(/ /g, '')
    },
  },
  props: {
    branch: Object,
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PageBranchDetail.breadcrumbs.index'),
          path: this.localePath({ name: 'branch' }),
        },
        {
          title: `<span class="d-none d-md-inline">${this.$t('PageBranchDetail.breadcrumbs.branch')}</span> ${
            this.branch.title
          }`,
          path: this.localePath({ name: 'branch-slug', params: { slug: this.$route.params.slug } }),
        },
      ],
      lightboxComponent: null,
    }
  },
  head() {
    return this.getSeoHead()
  },
  methods: {
    async openImage(index) {
      this.lightboxComponent = (await import('@theme/components/utils/LightboxGallery')).default
      this.$nextTick(() => {
        this.$refs.gallery.open(index)
      })
    },
  },
  created() {
    this.CLASS_INFO_LABEL = 'col-24 col-md-9'
    this.CLASS_INFO_VALUE = 'col-24 col-md-15'
  },
}
